import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query';

const { app } = PULSE;

export const contentBaseQuery = fetchBaseQuery({
    baseUrl: app.environment.aflApi,
    prepareHeaders: (headers) => {
        headers.set(app.accountHeader.label, app.accountHeader.value);
        return headers;
    }
});
